import { useEffect, useState } from 'react';
import { useSetting } from '../units/setting';
import moment from 'moment';

export type LoginState = {
    line_uid: string,
    login: string,
};

const KEY = 'ucpt-login-state';

const DEFAULT_DATA = {
    line_uid: '',
    login: '',
};

export function useLoginState() {
    const { setting } = useSetting();
    const [loginState, setInnerLoginState] = useState<LoginState>(getStorageLoginState());

    useEffect(() => {
        setLoginState(getStorageLoginState());
    }, []);

    function getDefaultData() {
        const defaultData = { ...DEFAULT_DATA };
        if (setting.loginConfig.isAutoLogin && setting.loginInfo.expiryDate > moment().unix()) {
            defaultData.login = setting.loginInfo.login;
        }

        return defaultData;
    }

    function getStorageLoginState() {
        const storageLoginState = sessionStorage.getItem(KEY);
        if (storageLoginState) {
            try {
                return JSON.parse(storageLoginState);
            } catch (e) {
                return getDefaultData();
            }
        } else {
            return getDefaultData();
        }
    }

    function setLoginState(data: LoginState) {
        setInnerLoginState({ ...data });
        sessionStorage.setItem(KEY, JSON.stringify({ ...data }));
    }

    function clear() {
        setLoginState({ ...DEFAULT_DATA });
    }

    return {
        loginState,
        setLoginState,
        clear,
    };
}
